import {Button} from '@chekinapp/ui';
import {useTranslation} from 'react-i18next';
import warningIcon from 'assets/icons/warning-icon.svg?no-inline';
import ModalSheet from 'components/common/ModalSheet';
import {ModalContent} from 'components/Modal/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onBackToStart?: () => void;
};

export function InvalidQRModal({open, onClose, onBackToStart}: Props) {
  const {t} = useTranslation('identity-verification');

  return (
    <ModalSheet
      isOpenModalSheet={open}
      withCloseButton
      maxWidth={375}
      modalMobileHeight={'432px'}
      className="invalid-qr-modal"
      onClose={onClose}
      withModalMobileCloseButton
    >
      <div className="space-y-6 flex flex-col items-center">
        <ModalContent
          title={t('invalid_qr_modal.title')}
          iconSrc={warningIcon}
          iconProps={{width: 67, height: 67}}
          text={t('invalid_qr_modal.description')}
        />
        <div className="flex flex-col gap-4 w-full">
          <Button onClick={onClose}>{t('invalid_qr_modal.try_again')}</Button>
          <Button onClick={onBackToStart} variant="link">
            {t('invalid_qr_modal.back_to_start')}
          </Button>
        </div>
      </div>
    </ModalSheet>
  );
}
